import deliveryMethods from '../mixins/delivery-methods'
export default {
  methods: {
    /**
     * ユーザーコードをSessionStorageから取得
     */
    getUserCode () {
      if (sessionStorage && Object.prototype.hasOwnProperty.call(sessionStorage, deliveryMethods.USER_SESSION_SAVE_KEY)) {
        var account = JSON.parse(sessionStorage.getItem(deliveryMethods.USER_SESSION_SAVE_KEY))
        if (account) {
          return account.user_code
        }
      }
      // セッション情報が無い場合、ログイン画面に戻す
      this.$router.replace('/login')
      throw new Error('Session Timeout Error')
    },
    /**
     * 更新日時を変換し返却を行う
     * @param {*} updateDate 更新日時
     * @returns unixTime -> String
     */
    convertUpdateDateUnixTimeToString (updateDate) {
      var toDoubleDigits = function (num) {
        num += ''
        if (num.length === 1) {
          num = '0' + num
        }
        return num
      }

      let dateTime = new Date(updateDate * 1000)
      var yyyy = dateTime.getFullYear()
      var mm = toDoubleDigits(dateTime.getMonth() + 1)
      var dd = toDoubleDigits(dateTime.getDate())
      var result = yyyy + '-' + mm + '-' + dd
      // result = result.replace(/\//g, "-");
      return result
    },
    /**
     * ユーザーセッションからクリニック名を取得し返却を行う
     * @returns クリニック名
     */
    getMyPageNameFromUserSession () {
      if (sessionStorage && Object.prototype.hasOwnProperty.call(sessionStorage, deliveryMethods.USER_SESSION_SAVE_KEY)) {
        var account = JSON.parse(sessionStorage.getItem(deliveryMethods.USER_SESSION_SAVE_KEY));        
        return account.name + '様';
      }
      return 'ようこそ○○○○○様'
    },
    getMyPageLoginIdFromUserSession () {
      if (sessionStorage && Object.prototype.hasOwnProperty.call(sessionStorage, deliveryMethods.USER_SESSION_SAVE_KEY)) {
        var account = JSON.parse(sessionStorage.getItem(deliveryMethods.USER_SESSION_SAVE_KEY));        
        return account.login_id;
      }
      return ''
    },
    /**
     * ブラウザバックを行う
     */
    browserBack () {
      this.$router.go(-1)
    },
    /**
     * セッションストレージからユーザーIDを取り出し返却を行う
     */
    getUserId () {
      if (!sessionStorage || !Object.prototype.hasOwnProperty.call(sessionStorage, deliveryMethods.USER_SESSION_SAVE_KEY)) {
        return null
      }

      var account = JSON.parse(sessionStorage.getItem(deliveryMethods.USER_SESSION_SAVE_KEY))
      return account ? account.login_id : null
    },

    /**
     * 表示用に機器リストを並び替えて返却を行う
     * 専用機器、共通機器の順に並び替えを行う
     * @param {*} machineList 機器リスト
     * @returns 専用、共通の順番に並んだ機器リスト
     */
    getMachineList (machineList) {
      var result = [] // Home画面の初期表示で○を2つ出すためリストに空文字を2つ追加している
      if (machineList.length > 0) {
      // 専用のみを抽出しリストに追加
        for (let i = 0; i < machineList.length; i++) {
          if (machineList[i].is_common === 0) {
            result.push(machineList[i])
          }
        }

        // 共通のみを抽出しリストに追加
        for (let i = 0; i < machineList.length; i++) {
          if (machineList[i].is_common === 1) {
            result.push(machineList[i])
          }
        }
      } else {
        result = ['', '']
      }

      return result
    },
    /**
     * 同一タブでリンクを開くかどうかドメインを確認
     */
    checkDomain (url) {
      if (url === undefined) {
        return false
      }
      if (deliveryMethods.DOMAIN === 0 && url.includes('jmec-support.com')) {
        return true
      }
      if (deliveryMethods.DOMAIN === 1 && url.includes('cedge-inc-support.com')) {
        return true
      }
      if (deliveryMethods.DOMAIN === 2 && url.includes('contactym-inc-support.com')) {
        return true
      }

      return false
    },
    /**
    * ドメインが一致しているかを確認
    */
    isDomain (domain) {
      if (deliveryMethods.DOMAIN === domain) {
        return true
      }
      return false
    },
    /**
     * スマホ判定
     * @returns true:スマホ false:その他
     */
    isSmartPhone () {
      // 画面サイズで判定
      if (window.matchMedia && window.matchMedia('(max-device-width: 770px)').matches) {
        return true
      } else {
        return false
      }
    },
    /**
     * パスワードの入力制限を行う
     * @param {*} inputPassword パスワード
     * @returns
     */
    isMatchPasswordFormat (inputPassword) {
      return inputPassword.match(/^([a-zA-Z0-9]{8,})$/)
    },

    /**
     * メールアドレスのフォーマットチェックを行う
     * @param {*} inputEmailAddress 入力されたメールアドレス
     * @returns
     */
    isMatchMailAddressFormat (inputEmailAddress) {
      return inputEmailAddress.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/)
    },
    browserBack () {      
      this.$router.back();
    },
    /**
     * 注文発注フォームの送料についての備考の返却を行う
     * @param {*} type 
     * @returns 
     */
    getPostageRemarks (type) {
      switch (type) {
        case 0:
          return deliveryMethods.POSTAGE_REMARKS.RESTYLANE;
        case 1:
          return deliveryMethods.POSTAGE_REMARKS.VARIOUS_CONSUMABLES;
        case 2:
          return deliveryMethods.POSTAGE_REMARKS.TREATMENT_PAMPHLETS_AND_POSTERS;
        case 3:
          return deliveryMethods.POSTAGE_REMARKS.MIRA_DRY;
        case 4:
          return deliveryMethods.POSTAGE_REMARKS.SOFWAVE;
        default:
          throw new Error('Not applicable value');
      }
    },
    /**
    * 表示対象項目を数値(10進数)から配列に変換
    * @param {*} displayItemsDecimalNumber ※10進数
    */
    convertDisplayItemsToStringArray (displayItemsDecimalNumber) {
      var displayItems = [];
      if (!displayItemsDecimalNumber) {
        return [
          deliveryMethods.DISPLAY_ITEM_LIST.RESTYLANE,
          deliveryMethods.DISPLAY_ITEM_LIST.CONSUMABLES,
          deliveryMethods.DISPLAY_ITEM_LIST.PAMPHLET_POSTER,
          deliveryMethods.DISPLAY_ITEM_LIST.MIRADRY,
          deliveryMethods.DISPLAY_ITEM_LIST.WEBSHOP,
          deliveryMethods.DISPLAY_ITEM_LIST.SOFWAVE,
        ];
      }

      if (displayItemsDecimalNumber == 0) {
        return [deliveryMethods.DISPLAY_ITEM_LIST.NONE];
      } 

      var binaryNumber = displayItemsDecimalNumber.toString(2); // 2進数          
      
      if (binaryNumber.charAt(binaryNumber.length - 1) && binaryNumber.charAt(binaryNumber.length - 1) == "1") {
        displayItems.push(deliveryMethods.DISPLAY_ITEM_LIST.RESTYLANE);
      }
      if (binaryNumber.charAt(binaryNumber.length - 2) && binaryNumber.charAt(binaryNumber.length - 2) == "1") {
        displayItems.push(deliveryMethods.DISPLAY_ITEM_LIST.CONSUMABLES);
      }
      if (binaryNumber.charAt(binaryNumber.length - 3) && binaryNumber.charAt(binaryNumber.length - 3) == "1") {
        displayItems.push(deliveryMethods.DISPLAY_ITEM_LIST.PAMPHLET_POSTER);
      }
      if (binaryNumber.charAt(binaryNumber.length - 4) && binaryNumber.charAt(binaryNumber.length - 4) == "1") {
        displayItems.push(deliveryMethods.DISPLAY_ITEM_LIST.MIRADRY);
      }
      if (binaryNumber.charAt(binaryNumber.length - 5) && binaryNumber.charAt(binaryNumber.length - 5) == "1") {
        displayItems.push(deliveryMethods.DISPLAY_ITEM_LIST.WEBSHOP);
      }
      if (binaryNumber.charAt(binaryNumber.length - 6) && binaryNumber.charAt(binaryNumber.length - 6) == "1") {
        displayItems.push(deliveryMethods.DISPLAY_ITEM_LIST.SOFWAVE);
      }
                
      // ソート
      displayItems.sort((x, y) => {
        return deliveryMethods.DISPLAY_ITEM_SORT.indexOf(x) - deliveryMethods.DISPLAY_ITEM_SORT.indexOf(y);
      });
                
      return displayItems;
    }, 
    /**
     * クリニックコードを配列から文字列に変換を行う
     * @param {*} clinicCodes クリニックコードの配列
     * @returns クリニックコードの文字列(クリニック名,クリニック名,...)
     */
    convertClinicCodeToString (clinicCodes) {
      var result = "";
      clinicCodes.forEach(function (item, index) {
        if (index === clinicCodes.length - 1) {
          result = result + item;
        } else {
          result = result + item + ",";
        }
      });
      return result;
    },
    /**
     * クリニックコードの文字列を配列に変換を行う
     * @param {*} clinicCodes クリニックコードの文字列(クリニック名,クリニック名,...)
     * @returns クリニックコードの配列
     */
    convertClinicCodeToList (clinicCodes) {      
      return clinicCodes.split(',');
    },
    /**
     * ページスクロールの有効化を行う
     */
    enablePageScroll () {
      document.body.style.overflow = '';
    },
    /**
     * ページスクロールの無効化を行う
     */
    disablePageScroll () {
      document.body.style.overflow = 'hidden';
    },
    /**
     * モバイル端末表示判定を行う
     * @returns true : モバイル端末 / false : PC
     */
    checkMobile() {
      const userAgent = navigator.userAgent.toLowerCase();      
      return /iphone|ipod|android|windows phone/i.test(userAgent);
    },
    /**
     * 商品の個数選択の表示可否を判定し返却を行う
     * 注文可能数がnullの場合は表示可能とする
     * @param {*} numberOfOrdersAvailable 表示可能数
     * @param {*} quantity 個数(1から5まで)
     */
    canSelectedQuantity (numberOfOrdersAvailable, quantity) {

      if (numberOfOrdersAvailable == null) {
        return true;
    }

      return numberOfOrdersAvailable - quantity >= 0;
    },
    backHome() {
      this.$router.replace('/home');
    },
    /**
     * 出庫先情報を元に注文機能の表示有無の返却を行う
     * @param {*} clinicInfo 出庫先情報
     * @returns 
     */
    showOrderFunction (clinicInfo) {
      return clinicInfo != null && clinicInfo.agency_sales == 0;
  }
}
}



// WEBPACK FOOTER //
// ./src/mixins/Util.js